module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "florida"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ALT-act"
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_florida",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("FLORIDA. THIRTY-THREE YEARS LATER.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“All right if I turn on the tape recorder?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yeah. It’s all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Can you tell me what you remember about that day and what you found?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Why are you talking to me anyway? Have you gone through the agency handling this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Through the agency. In Miami?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“This is still an open case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Still an open case, yeah. Unsolved.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Never closed. And federal testimony was sealed. I haven’t discussed this case with anybody for some period of time. When was it, seventy-six?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yes, seventy-six.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“I don’t want to give you any information that isn’t correct. You’re welcome to ask.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Some guys found him … some young guys fishing in the bay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yeah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“They found an oil drum floating in the water. They said they could see through the holes in the drum what they thought were human remains.…”")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“They saw something. They called it in. I went to the scene. We had the marine patrol boat come tow the drum up to the shore. We asked them to pull the drum up onto the back of their boat. But they weren’t going to put the damn thing on their boat. So they towed it to shore and we got a tow truck to take it out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“You knew right away there was a body inside the oil drum?")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“There was a stink coming out of it. We were pretty sure this thing was going to the M.E. office.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“To the medical examiner?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yeah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“You opened the drum there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“It was opened at the scene. The tow driver helped us open it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“What did you see inside?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“It was a big blob.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“A blob?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Exactly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“It didn’t look human?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Gray-and-white blob. With a powerful smell.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“The body was decomposed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“It was bloated. It was bloated as it could get inside of this drum. It was filled up with body gas and deterioration being in the water and salt water coming inside.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“The legs were separated … chopped off—”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Right. Jammed in there with the body. Along the side.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Not a pretty sight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“It was not something you saw every day. Then again…”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“The oil drum was never meant to be found, right? An anchor or something probably broke off and it floated up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yeah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Somebody screwed up.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“That’s an opinion. My opinion is that it was not meant to come back to the surface.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“How long was it before you got an ID on the body?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Couple of days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“The report says it was tough getting prints from the fingers because they were so deteriorated. All they could print was part of one thumb.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Yeah?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Said he was shot in the gut, and then the bullet was dug out of the flesh. One of the stories in the paper said he was still alive when they put him in the oil drum.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Well, if I knew about that I probably wouldn’t say … because it’s still an open case. If some guy somewhere wants to confess, the policeman can know if the guy is for real or he’s full of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Murders were pretty common in that part of Florida.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“They were shooting up half of Miami back then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Cocaine wars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Bodies were being found all the time. I think we came close to setting the world record for homicides.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“But when you found out who was in the oil drum it became a big deal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“They all came down on us. Government. FBI. The press. The Central Intelligence Agency was interested in this guy. Senator Gary Hart runs down here and he wants to know all about it. Of course he was getting ready to run for president.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Did the government people try to control the investigation?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“The whole city of Washington and the whole federal law enforcement that got involved with the Rosselli case were all full of shit. I firmly believe that they knew more than they were telling us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Many people believe Rosselli’s murder was a result of his")]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "4",
      "id": "pg_4",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("testimony at the hearings in Washington—that it was tied to all the talk about the CIA/Castro plot, the Kennedy assassination.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Johnny Rosselli had been talking way too much. We found out that he had pissed off a lot of people. He lived a charmed life for a long while. But he didn’t realize he had gotten old and the charm had worn off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“He kept saying that nobody was going to bother a retired old man.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Well. He got that wrong.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ddd66ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/florida.vue
// module id = 72
// module chunks = 0